import { httpRepo } from "configurations/axios";
import {
  UPDATE_ESTADO_CONTABLE_REQUEST,
  UPDATE_ESTADO_CONTABLE_SUCCESS,
  UPDATE_ESTADO_CONTABLE_FAILURE,
  UPDATE_ESTADO_CONTABLE_RESET,
} from "redux/types/estadoContableTypes";

const API_UPDATE_ESTADO_CONTABLE = "/comprobante/actualizar/estado-contable/";

const getErrorMessage = (error, fallbackMessage) =>
  error?.response?.data?.message ||
  error?.response?.data?.apierror?.mensaje ||
  error?.response?.data ||
  error?.message ||
  fallbackMessage;

export const updateEstadoContable = (idFactura, nuevoEstado, fechaPago) => async (dispatch) => {
  dispatch({ type: UPDATE_ESTADO_CONTABLE_REQUEST });

  try {
    if (!idFactura) {
      throw new Error("No se pudo determinar la factura a actualizar.");
    }

    if (nuevoEstado === undefined || nuevoEstado === null || nuevoEstado === "") {
      throw new Error("No se pudo determinar el nuevo estado contable.");
    }

    let url = `${API_UPDATE_ESTADO_CONTABLE}${idFactura}?estadoContable=${encodeURIComponent(nuevoEstado)}`;
    if (fechaPago) {
      url += `&fechaPago=${encodeURIComponent(fechaPago)}`;
    }

    const response = await httpRepo.put(url);

    dispatch({
      type: UPDATE_ESTADO_CONTABLE_SUCCESS,
      payload: response.data,
    });

    return response.data;
  } catch (error) {
    const message = getErrorMessage(
      error,
      "No se pudo actualizar el estado contable.",
    );

    dispatch({
      type: UPDATE_ESTADO_CONTABLE_FAILURE,
      payload: message,
    });

    throw error;
  }
};

export const resetUpdateEstadoContable = () => ({
  type: UPDATE_ESTADO_CONTABLE_RESET,
});
